import TPreviewFormat from '@/ui/preview-file/types/TPreviewFormat'

export const previewFormats: Record<TPreviewFormat, string[]> = {
  img: ['png', 'jpg', 'jpeg', 'gif'],
  pdf: ['pdf'],
  doc: ['doc', 'docx'],
  excel: ['xls', 'xlsx'],
  text: ['txt'],
}
